export const PASSPORT_NAME_FIRST_NAME = 'passportNameFirstName';
export const PASSPORT_NAME_LAST_NAME = 'passportNameLastName';
export const USER_EMAIL = 'userEmail';
